class ViewToggle {
  constructor() {
    this.selectors = {
      gridBtn: '#grid-view-btn',
      listBtn: '#list-view-btn',
      grid: '.product-grid',
      gridContainer: '#ProductGridContainer' 
    };
    
    this.init = this.init.bind(this);
    this.setView = this.setView.bind(this);
    this.handleMutations = this.handleMutations.bind(this);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', this.init);
    } else {
      this.init();
    }
  }
  
  init() {
    this.updateElements();
    
    const savedView = localStorage.getItem('productView') || 'grid';
    this.setView(savedView, false); 
    document.addEventListener('click', (e) => {
      if (e.target.closest(this.selectors.gridBtn)) {
        this.setView('grid');
      } else if (e.target.closest(this.selectors.listBtn)) {
        this.setView('list');
      }
    });

    const observerContainer = document.querySelector(this.selectors.gridContainer) || document.body;
    
    this.observer = new MutationObserver(this.handleMutations);
    this.observer.observe(observerContainer, {
      childList: true, 
      subtree: true    
    });
  }
  
  updateElements() {
    this.productGrid = document.querySelector(this.selectors.grid);
    this.gridBtns = document.querySelectorAll(this.selectors.gridBtn);
    this.listBtns = document.querySelectorAll(this.selectors.listBtn);
  }

  handleMutations(mutations) {
    let shouldUpdate = false;
    
    for (const mutation of mutations) {
      if (mutation.addedNodes.length > 0) {
        if (mutation.target.classList.contains('product-grid') || 
            mutation.target.id === 'ProductGridContainer' ||
            (mutation.target.closest && mutation.target.closest('.product-grid'))) {
          shouldUpdate = true;
          break;
        }
      }
    }

    if (shouldUpdate) {
      const savedView = localStorage.getItem('productView') || 'grid';
      setTimeout(() => {
        this.updateElements(); 
        this.setView(savedView, false);
      }, 50);
    }
  }
  
  setView(viewType, save = true) {
    this.updateElements();
    
    if (!this.productGrid) return;

    if (viewType === 'list') {
      this.productGrid.classList.add('product-grid--list');
      document.documentElement.classList.add('view-list-active'); // Helper untuk CSS anti-glitch
    } else {
      this.productGrid.classList.remove('product-grid--list');
      document.documentElement.classList.remove('view-list-active');
    }
    
    this.gridBtns.forEach(btn => btn.classList.toggle('active', viewType === 'grid'));
    this.listBtns.forEach(btn => btn.classList.toggle('active', viewType === 'list'));
    
    if (save) {
      localStorage.setItem('productView', viewType);
    }
  }
}

new ViewToggle();